/* ============================================================
   KaNi Candy - Schnellkauf und Hinzugefuegt-Meldung
   Laeuft auf jeder Seite (layout/theme.liquid).

   1. Jeder Knopf mit [data-kani-add="<Varianten-ID>"] legt ein Stueck in
      den Warenkorb: Produktkarten, Zubehoerreihe. Der Knopf zeigt kurz
      einen gruenen Haken.
   2. Nach jedem Hinzufuegen - auch ueber Dawns Formular auf der
      Produktseite - erscheint oben kurz eine gruene Meldung mit dem
      Produktnamen und "Zum Warenkorb". Der Warenkorb selbst klappt nicht
      mehr auf: Dawns Benachrichtigung wird dafuer umgelenkt.
   ============================================================ */
(function () {
  'use strict';

  var WURZEL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var handy = window.matchMedia('(max-width:759px)');

  /* ---------- Meldung ---------- */
  var meldung, meldungName, meldungTimer;

  function baueMeldung() {
    meldung = document.createElement('div');
    meldung.className = 'kani-toast';
    meldung.setAttribute('role', 'status');
    meldung.setAttribute('aria-live', 'polite');
    meldung.innerHTML =
      '<span class="kani-toast__haken" aria-hidden="true">' +
        '<svg viewBox="0 0 24 24" fill="none"><path d="M6.5 12.5 10.5 16.5 17.5 8.5" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</span>' +
      '<span class="kani-toast__name"></span>' +
      '<a class="kani-toast__link" href="' + WURZEL + 'cart">Zum Warenkorb</a>';
    meldungName = meldung.querySelector('.kani-toast__name');

    /* Auf dem Handy oeffnet "Zum Warenkorb" das Klappfenster, wie ein Tipp
       auf die Tuete im Header - am Schreibtisch bleibt es der Link. */
    meldung.querySelector('.kani-toast__link').addEventListener('click', function (e) {
      var tuete = document.getElementById('cart-icon-bubble');
      schliesse();
      if (handy.matches && tuete && document.getElementById('kani-warenkorb')) {
        e.preventDefault();
        tuete.click();
      }
    });

    /* Solange der Finger oder die Maus drauf ist, bleibt sie stehen. */
    meldung.addEventListener('pointerenter', function () { window.clearTimeout(meldungTimer); });
    meldung.addEventListener('pointerleave', function () { spaeterZu(1500); });

    document.body.appendChild(meldung);
  }

  function schliesse() {
    if (meldung) meldung.classList.remove('is-da');
  }

  function spaeterZu(ms) {
    window.clearTimeout(meldungTimer);
    meldungTimer = window.setTimeout(schliesse, ms);
  }

  function zeige(name) {
    if (!meldung) baueMeldung();
    meldungName.textContent = name || 'Im Warenkorb';
    meldung.classList.remove('is-da');
    /* Einmal Layout erzwingen, damit die Einblendung auch bei schnellem
       zweiten Tipp neu ablaeuft. */
    void meldung.offsetWidth;
    meldung.classList.add('is-da');
    spaeterZu(2800);
  }

  window.KaniMeldung = { zeigen: zeige, schliessen: schliesse };

  /* ---------- Warenkorb-Tuete im Header auffrischen ---------- */
  function tueteSetzen(html) {
    var ziel = document.getElementById('cart-icon-bubble');
    if (!ziel || !html) return false;
    var d = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
    if (!d) return false;
    ziel.innerHTML = d.innerHTML;
    return true;
  }

  function tueteLaden() {
    fetch(WURZEL + '?section_id=cart-icon-bubble')
      .then(function (r) { return r.text(); })
      .then(tueteSetzen)
      .catch(function () {});
  }

  function gemeldet() {
    /* Dawns Bausteine (Warenkorbseite, Mengenzaehler) hoeren darauf. */
    if (window.publish && window.PUB_SUB_EVENTS) {
      try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'kani-schnellkauf' }); } catch (e) {}
    }
  }

  /* ---------- 1. Schnellkauf-Knopf ---------- */
  function hinzufuegen(knopf) {
    var id = knopf.getAttribute('data-kani-add');
    if (!id || knopf.disabled) return;
    knopf.disabled = true;
    knopf.classList.add('is-laed');

    fetch(WURZEL + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(id), quantity: 1 }],
        sections: 'cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        knopf.classList.remove('is-laed');
        if (!res.ok) throw new Error(res.body.description || res.body.message || 'Fehler');

        knopf.classList.add('is-fertig');
        window.setTimeout(function () { knopf.classList.remove('is-fertig'); }, 1800);

        var zeile = res.body.items ? res.body.items[0] : res.body;
        zeige(zeile && zeile.product_title);
        if (!(res.body.sections && tueteSetzen(res.body.sections['cart-icon-bubble']))) tueteLaden();
        gemeldet();
      })
      .catch(function () {
        /* Nur wenn das Hinzufuegen selbst scheitert (z. B. Bestand zu
           knapp): zur Produktseite, dort sieht der Kunde, was los ist. */
        knopf.classList.remove('is-laed');
        var karte = knopf.closest('.kani-card, .kani-zubehoer__karte');
        var link = karte && karte.querySelector('a[href*="/products/"]');
        if (link) window.location.href = link.href;
      })
      .then(function () { knopf.disabled = false; });
  }

  document.addEventListener('click', function (e) {
    var knopf = e.target.closest('[data-kani-add]');
    if (!knopf) return;
    e.preventDefault();
    hinzufuegen(knopf);
  });

  /* ---------- 2. Dawns Benachrichtigung umlenken ----------
     Das Formular der Produktseite ruft nach dem Hinzufuegen
     cart-notification.renderContents() auf, das die Tuete auffrischt und
     das Fenster aufklappt. Statt aufzuklappen zeigen wir die Meldung. */
  if (window.customElements) {
    customElements.whenDefined('cart-notification').then(function () {
      var Klasse = customElements.get('cart-notification');
      Klasse.prototype.renderContents = function (stand) {
        var abschnitte = (stand && stand.sections) || {};
        if (!tueteSetzen(abschnitte['cart-icon-bubble'])) tueteLaden();
        var zeile = stand && stand.items ? stand.items[0] : stand;
        zeige(zeile && zeile.product_title);
      };
    });
  }
})();
